import { fetchData, apiURL } from './api_helper';

// Syllabus (tanmenet) alignment — Classroom 1.2, epic BE-3088. Backend: xeropan-nexus-api
// `syllabus` service (BE-3094 / BE-3095), aliases under /api/classes/:classId/syllabus,
// /api/syllabus/jobs/:jobId and /api/syllabus/:id/*. Mirrors aiLessons.js: each call resolves
// result.data.
const base = `${apiURL}/api`;

// Resolves the class's live syllabus or null when it has none (the backend answers 404
// SYLLABUS_NOT_FOUND, mapped to null so the entry-point CTAs can simply check for a falsy value).
const getClassSyllabus = classId => new Promise((resolve, reject) => {
  fetchData(`${base}/classes/${classId}/syllabus`, 'GET')
    .then(result => resolve(result.data || null))
    .catch((error) => {
      if (error && error.response && error.response.status === 404) resolve(null);
      else reject(error);
    });
});

// Multipart upload of one document or several photos (one `file` part each, page order
// preserved); resolves { syllabusId, jobId } (202). `fields` = { forceLanguage, replace }.
const uploadSyllabus = (classId, files, fields) => new Promise((resolve, reject) => {
  const body = { files: Array.from(files || []), fields: fields || {} };
  fetchData(`${base}/classes/${classId}/syllabus/upload`, 'FILE', body)
    .then(result => resolve(result.data)).catch(reject);
});

// { jobId, syllabusId, status, phase, progressPct, errorCode, errorDetail, result }
const getSyllabusJob = jobId => new Promise((resolve, reject) => {
  fetchData(`${base}/syllabus/jobs/${jobId}`, 'GET')
    .then(result => resolve(result.data)).catch(reject);
});

// { cancelled } — false when the job had already finished.
const cancelSyllabusJob = jobId => new Promise((resolve, reject) => {
  fetchData(`${base}/syllabus/jobs/${jobId}/cancel`, 'POST')
    .then(result => resolve(result.data)).catch(reject);
});

// The check step (XWEB-1203). Each call answers the refreshed syllabus summary (the same
// shape as getClassSyllabus), so the store can simply replace the cached one.

// "Igen, jól olvastuk be →"
const confirmSyllabus = id => new Promise((resolve, reject) => {
  fetchData(`${base}/syllabus/${id}/confirm`, 'POST', {})
    .then(result => resolve(result.data)).catch(reject);
});

// scope: 'next8' | 'semester' | 'year'
const setSyllabusScope = (id, scope) => new Promise((resolve, reject) => {
  fetchData(`${base}/syllabus/${id}/review-scope`, 'POST', { scope })
    .then(result => resolve(result.data)).catch(reject);
});

// A syllabus without dates: 1–4 class hours a week, every date recomputed on the server.
const setSyllabusLessonsPerWeek = (id, lessonsPerWeek) => new Promise((resolve, reject) => {
  fetchData(`${base}/syllabus/${id}/lessons-per-week`, 'POST', { lessonsPerWeek })
    .then(result => resolve(result.data)).catch(reject);
});

// "Valami nem stimmel" -> which way out the teacher took: 'edit' | 'reupload'. Logging only.
const reportSyllabusIssue = (id, choice) => new Promise((resolve, reject) => {
  fetchData(`${base}/syllabus/${id}/issue`, 'POST', { choice })
    .then(result => resolve(result.data)).catch(reject);
});

const archiveSyllabus = id => new Promise((resolve, reject) => {
  fetchData(`${base}/syllabus/${id}/archive`, 'POST', {})
    .then(result => resolve(result.data)).catch(reject);
});

// "Újrapróbálás": reads the chapters the background run could not read again; answers the summary.
const retrySyllabusLessons = id => new Promise((resolve, reject) => {
  fetchData(`${base}/syllabus/${id}/retry-lessons`, 'POST', {})
    .then(result => resolve(result.data)).catch(reject);
});

// TEMP(DEV): the parsed rows for the check card's DEV panel.
const getSyllabusLessons = id => new Promise((resolve, reject) => {
  fetchData(`${base}/syllabus/${id}/lessons`, 'GET')
    .then(result => resolve(result.data)).catch(reject);
});

export default {
  getClassSyllabus,
  archiveSyllabus,
  getSyllabusLessons,
  uploadSyllabus,
  getSyllabusJob,
  cancelSyllabusJob,
  confirmSyllabus,
  setSyllabusScope,
  setSyllabusLessonsPerWeek,
  reportSyllabusIssue,
  retrySyllabusLessons
};



// WEBPACK FOOTER //
// ./src/api/syllabus.js